export default "__VITE_ASSET__CNZ13Yms__"